import React from "react";
import PropTypes from "prop-types";

class RefundModal extends React.Component {
    render() {
        return (
            <div>
                Re you sure you want refund transaction?
                <div className="text-right mt-3">
                    <button
                        className="btn btn-danger mr-2"
                        onClick={this.props.onCancel}
                    >
                        Cancel
                    </button>
                    <button
                        className="btn btn-success"
                        onClick={this.props.onSubmit}
                    >
                        Yes
                    </button>
                </div>
            </div>
        );
    }
}

RefundModal.propTypes = {
    onSubmit: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
};

export default RefundModal;



// WEBPACK FOOTER //
// ./src/views/pages/transaction/refund-modal.js